// extracted by mini-css-extract-plugin
export default {"Marquee":"Marquee_Marquee__WdoI1","Track":"Marquee_Track__fusef","Text":"Marquee_Text__oJxWk"};